import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton, ListItemSecondaryAction } from "@mui/material";
import { useNotification } from "app/NotificationProvider";
import { AnalyticsEvents, analytics } from "common/analytics";
import { useTranslation } from "common/locales";
import { ManualDMInputResponse } from "model";
import {
  deleteAllTilesForField,
  invalidateFieldData,
  updateOneReading,
} from "services";

export default function FieldEventConfirmationMenu({
  machineInput,
  children,
}: {
  machineInput: ManualDMInputResponse;
  children?: React.ReactNode;
}) {
  const { t } = useTranslation();
  const { notify } = useNotification();
  return (
    <ListItemSecondaryAction>
      <IconButton
        edge="end"
        onClick={() => handleAcceptMachineReading(machineInput)}
        aria-label={t("fieldevents.menu.accept")}
        size="large"
      >
        <CheckIcon />
      </IconButton>
      <IconButton
        edge="end"
        onClick={() => handleRejectMachineReading(machineInput)}
        aria-label={t("fieldevents.menu.reject")}
        size="large"
      >
        <ClearIcon />
      </IconButton>
      {children}
    </ListItemSecondaryAction>
  );
  async function handleAcceptMachineReading(reading: ManualDMInputResponse) {
    try {
      await updateOneReading({
        ...reading,
        manualDryMatterInput: {
          ...reading.manualDryMatterInput,
          verificationStatus: "Accepted",
        },
      });
      notify(t("fieldevents.notify.accepted"));
      analytics.track(AnalyticsEvents.AUTODETECTED_EVENT_ACCEPTED);
      await deleteAllTilesForField(reading.manualDryMatterInput.field);
      invalidateFieldData(reading.manualDryMatterInput.field);
    } catch (e) {
      console.error("Failed to accept machine reading:", e);
    }
  }
  async function handleRejectMachineReading(reading: ManualDMInputResponse) {
    try {
      await updateOneReading({
        ...reading,
        manualDryMatterInput: {
          ...reading.manualDryMatterInput,
          verificationStatus: "Rejected",
        },
      });
      notify(t("fieldevents.notify.rejected"));
      analytics.track(AnalyticsEvents.AUTODETECTED_EVENT_REJECTED);
      await deleteAllTilesForField(reading.manualDryMatterInput.field);
      invalidateFieldData(reading.manualDryMatterInput.field);
    } catch (e) {
      console.error("Failed to reject machine reading:", e);
    }
  }
}
